import { api } from "jiffy-api";

import "./claim-image-uploader.scss";

const $getUploadButton = () => document.querySelector(".js-claim-images-button");
const $getUploaderInfoContainer = () => document.querySelector(".js-claim-uploader-info");
const $getUploadInfoLabel = () => document.querySelector(".js-claim-upload-info-label");
const $getImageFilesSelector = () => document.querySelector(".js-claim-image-files");
const $getImageIdsField = () => document.querySelector(".js-claim-image-ids");
const $getDiscardButton = () => document.querySelector(".js-claim-discard-button");

const handleImagesSelected = async event => {
  event.preventDefault();

  const { files } = event.target;

  if (!files.length) return;

  const uploadButton = $getUploadButton();
  const uploaderInfoContainer = $getUploaderInfoContainer();
  const uploadInfoLabel = $getUploadInfoLabel();

  uploadButton.classList.add("hidden");
  uploaderInfoContainer.classList.remove("hidden");
  uploadInfoLabel.innerText = "Uploading...";

  const formData = new FormData();

  try {
    Array.from(files).forEach(file => {
      const { type } = file;

      if (type.startsWith("image/")) {
        formData.append("images[]", file);
      } else {
        throw new Error("You can't upload files of this type.");
      }
    });

    const response = await api.ordersClaims.uploadImages(formData, {
      raw: true,
      useAxiosForRequest: true,
      headers: { "Content-Type": undefined },
      onUploadProgress: ({ progress }) => {
        const currProgress = (progress * 100).toFixed();
        uploadInfoLabel.innerText = `Uploading ${currProgress}%`;
      }
    });

    const imageIds = response.image_ids;
    uploadInfoLabel.innerText = `${imageIds.length} images uploaded`;
    $getImageIdsField().value = imageIds.join(",");
  } catch (error) {
    uploadInfoLabel.innerText = error.message;
    console.error("Claim image upload: ", error);
  } finally {
    $getDiscardButton().classList.remove("hidden");
  }
};

const handleUploadButtonClick = event => {
  event.preventDefault();

  $getImageFilesSelector().click();
};

const handleDiscardButtonClick = event => {
  event.preventDefault();

  $getUploadButton().classList.remove("hidden");
  $getUploaderInfoContainer().classList.add("hidden");
  $getDiscardButton().classList.add("hidden");

  $getImageIdsField().value = "";
  $getImageFilesSelector().value = "";
};

const initClaimImageUploader = () => {
  $getImageFilesSelector().addEventListener("change", handleImagesSelected);
  $getUploadButton().addEventListener("click", handleUploadButtonClick);
  $getDiscardButton().addEventListener("click", handleDiscardButtonClick);
};

export default initClaimImageUploader;
